<template>
  <div>
    <el-table border :data="tableData" :header-cell-style="{background:'#f2f2f2',color:'black'}">
      <el-table-column
        :label="$t('Resource.VersionNum')" prop="currentVersion" width="120"
        align="center"
      />
      <el-table-column :label="$t('ChannelManage.SmallParcelCoefficient')" prop="smallCalculateBase">
        <template slot-scope="scope">
          <div>
            <span v-if="scope.row.smallCalculationMethod === 0">*</span>
            <span v-if="scope.row.smallCalculationMethod === 1">/</span>
            {{ scope.row.smallCalculateBase }}
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('ChannelManage.LargeParcelCoefficient')" prop="largeCalculateBase">
        <template slot-scope="scope">
          <div>
            <span v-if="scope.row.largeCalculationMethod === 0">*</span>
            <span v-if="scope.row.largeCalculationMethod === 1">/</span>
            {{ scope.row.largeCalculateBase }}
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('GlobalSetObj.CreatePeople')" prop="createUser">
        <template slot-scope="scope">
          {{ getUserName(scope.row.createUser, userNameStr) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('GlobalSetObj.UpdateTime')" prop="updateTime" width="180" />
    </el-table>
    <!-- 分页工具 -->
    <div class="pagination">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNumber"
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="queryParam.pageSize"
        :total="total"
        background
        style="margin: 10px 0"
        @current-change="getCurrentTable"
        @size-change="getSizeTable"
      />
    </div>
  </div>
</template>
<script>
import { channelVolumeConfigGetHistoryPage } from '@/api/finance/basicData';
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { getUserName } from '@/utils/asyncTools';
export default {
  name: 'VersionData',
  props: {
    versionData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      tableData: [],
      queryParam: {
        pageNumber: 1,
        pageSize: 20,
        params: {
          id: null
        }
      },
      total: 0,
      userNameStr: null
    };
  },
  created() {
    this.userNameStr = getUserIdAndNameObj();
    this.getHistoryData();
  },
  methods: {
    getUserName,
    getHistoryData() {
      this.queryParam.params.id = this.versionData.id;
      channelVolumeConfigGetHistoryPage(this.queryParam).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 翻页
    getCurrentTable(val) {
      this.queryParam.pageNumber = val;
      this.getHistoryData();
    },
    // 每页显示数量更改
    getSizeTable(val) {
      this.queryParam.pageSize = val;
      this.queryParam.pageNumber = 1;
      this.getHistoryData();
    }
  }
};
</script>

<style scoped>

</style>
